import React, { useContext, useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import AsyncSelect from "react-select/async";
// Images
import masterCardLogo from "assets/images/logos/mastercard.png";
import visaLogo from "assets/images/logos/visa.png";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import DateTimePicker from "react-datetime-picker";

import MDInput from "components/MDInput";
// import CreateFacilityTypeReq from 'Classes/Models/Requests/Administration/CreateFacilityTypeReq';
// import CreateSessionReq from 'Classes/Models/Requests/Administration/CreateSessionReq';
// import SessionsApi from 'Classes/API/Administration/SessionsApi';

import CreateUserReq from "../../Classes/Models/Requests/Users/CreateUserReq";
import CountrySelector from "layouts/authentication/sign-up/CountrySelector";
import UsersApi from "Classes/API/UsersApi";
import UserTypeSelector from "./UserDetails/components/UserTypeSelector";
import { LanguageContext } from "App";

const SearchUsers = ({ GetTableData, SearchReq, setSearchReq }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [Types, setTypes] = useState();
  const [TypesSearch, setTypesSearch] = useState();
  const [TypesLoaded, setTypesLoaded] = useState(false);

  const [Id, setId] = useState("");

  const [Name, setName] = useState("");
  const [Nationality, setNationality] = useState("");
  const [Phone, setPhone] = useState();
  const [Email, setEmail] = useState("");
  const [Address, setAddress] = useState("");
  const [UserType, setUserType] = useState("");
  const [IsActivated, setIsActivated] = useState("");
  const [IsSoftDeleted, setIsSoftDeleted] = useState("");

  const [ErrorText, setErrorText] = useState("");
  const [SuccessText, setSuccessText] = useState("");

  const { translations } = useContext(LanguageContext);

  const onSubmit = async () => {
    // copy the search request in new object
    let _SearchReq = Object.assign({}, SearchReq);

    _SearchReq.Id = Id;
    _SearchReq.Name = Name;
    _SearchReq.Nationality = Nationality;
    _SearchReq.Email = Email;
    _SearchReq.Address = Address;
    _SearchReq.UserType = UserType;
    _SearchReq.IsActivated = IsActivated;
    _SearchReq.Number = Phone;
    _SearchReq.IsSoftDeleted = IsSoftDeleted;
    console.log(_SearchReq);
    // GetTableData(SearchReq);
    setSearchReq(_SearchReq);
  };

  const clearFilter = async () => {
    location.reload();
  };

  return (
    <Card mb={3} id="SearchUsers">
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          {translations.userManagementPgHeader}
        </MDTypography>
      </MDBox>

      <form id="SearchUsersForm" className={translations.setlang === "ar" ? "rtl-label" : ""}>
        <MDBox p={3}>
          <MDBox
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={2}
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-4 mt-3">
                  <MDInput
                    type={"number"}
                    onChange={(e) => setId(e.target.value)}
                    label={translations.userManagementPgInputsId}
                    fullWidth
                  ></MDInput>
                </div>
                <div className="col-md-4 mt-3">
                  <MDInput
                    onChange={(e) => setName(e.target.value)}
                    label={translations.userManagementPgInputsName}
                    fullWidth
                  ></MDInput>
                </div>
                <div className="col-md-4 mt-3 ">
                  <CountrySelector
                    isClearable={true}
                    placeholder={translations.userManagementPgInputsNationality}
                    SetNationality={setNationality}
                    fullWidth
                  />
                </div>
                <div className="col-md-4 mt-3">
                  <MDInput
                    className="full-width"
                    onChange={(e) => setEmail(e.target.value)}
                    label={translations.userManagementPgInputsEmail}
                    fullWidth
                  ></MDInput>
                </div>
                <div className="col-md-4 mt-3">
                  <MDInput
                    className="full-width"
                    type={"text"}
                    onChange={(e) => setAddress(e.target.value)}
                    label={translations.userManagementPgInputsAddress}
                    fullWidth
                  ></MDInput>
                </div>
                <div className="col-md-4 mt-3">
                  <UserTypeSelector
                    placeholder={translations.userManagementPgInputsUserType}
                    setUserType={setUserType}
                  />
                </div>
                <div className="col-md-4 mt-3">
                  <MDInput
                    className="full-width"
                    type={"text"}
                    onChange={(e) => setPhone(e.target.value)}
                    label={translations.userManagementPgInputsPhone}
                    fullWidth
                  ></MDInput>
                </div>
                {/* <div className="col-md-4 mt-3">
                  <label style={{ fontSize: 16 }}>
                    <input
                      type="checkbox"
                      defaultChecked={IsActivated}
                      onChange={() => setIsActivated(!IsActivated)}
                      className="mr-2"
                    />
                    {translations.userManagementPgInputsIsActivated}
                  </label>
                </div>

                <div className="col-md-4 mt-3">
                  <label style={{ fontSize: 16 }}>
                    <input
                      type="checkbox"
                      defaultChecked={IsSoftDeleted}
                      onChange={() => setIsSoftDeleted(!IsSoftDeleted)}
                      className="mr-2"
                    />
                    {translations.userManagementPgInputsIsSoftDeleted}
                  </label>
                </div> */}
              </div>
              <MDBox pt={2} px={2} display="flex" justifyContent="end" alignItems="right">
                <MDButton
                  className="mt-3"
                  onClick={() => onSubmit()}
                  color="info"
                  sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                >
                  <Icon sx={{ fontWeight: "bold" }}>search</Icon>
                  &nbsp;{translations.userManagementPgInputsSearchUsersBtn}
                </MDButton>
              </MDBox>
            </div>

            <MDTypography variant="overline" color={"success"}>
              {SuccessText}
            </MDTypography>

            <MDTypography variant="overline" color={"error"}>
              {ErrorText}
            </MDTypography>
          </MDBox>
        </MDBox>
      </form>
    </Card>
  );
};

export default SearchUsers;
